import React, { Component } from 'react'
import { 
  Typography,
  TextField, 
  Button,
  Paper
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import styles from './styles'
import NavBar from '../../Components/NavBar'
import { Unauthenticated } from '../../Components/NavBar/rightToolbars'
import { passwordChecker, history } from '../../utils/utils'
class Register extends Component {
  state = {
    email: null,
    password: null,
    confirmPassword: null
  }
  classes = this.props.classes
  onSubmit = () => {
    this.props.register({ 
      user: {
        type: 'advertiser',
        email: this.state.email, 
        password: this.state.password 
      } 
    })
  }
  onInputChange = ({ target }, type) => {
    this.setState({ [type]: target.value })
  }
  render() {
    return (
      <div className={this.classes.container}>
        <NavBar t={this.props.t} >
          <Unauthenticated link='/login' text='logIn' t={this.props.t} />
        </NavBar>
        <Paper className={this.classes.paper}>
          <Typography variant='h3'>{this.props.t('signUp')}</Typography>
          <form className={this.classes.form} autoComplete='off'>
            <TextField
              label={this.props.t('email')}
              type='email'
              name='email'
              autoComplete='email'
              margin='normal'
              variant='outlined'
              onChange={(e) => this.onInputChange(e, 'email')}
            />
            <TextField
              label={this.props.t('password')}
              error={!passwordChecker(this.state.password, this.state.confirmPassword).status}
              helperText={this.props.t(passwordChecker(this.state.password, this.state.confirmPassword).message)}
              type='password'
              autoComplete='current-password'
              margin='normal'
              variant='outlined'
              onChange={(e) => this.onInputChange(e, 'password')}
            />
            <TextField
              label={this.props.t('confirmPassword')}
              error={!passwordChecker(this.state.confirmPassword, this.state.password).status}
              helperText={this.props.t(passwordChecker(this.state.password, this.state.confirmPassword).message)}
              type='password'
              autoComplete='current-password'
              margin='normal'
              variant='outlined'
              onChange={(e) => this.onInputChange(e, 'confirmPassword')}
            />
            <div>
              <Button
                onClick={() => history.push('/resetPassword')}
              >{this.props.t('forgotPassword')}</Button>
              <div className={this.classes.signInSignUp}>
                <Button
                  onClick={() => history.push('/login')}
                >{this.props.t('logIn')}</Button>
                <Button 
                  variant='contained' 
                  color='primary'
                  disabled={!passwordChecker(this.state.confirmPassword, this.state.password).status || !this.state.email}
                  onClick={this.onSubmit}
                >{this.props.t('signUp')}</Button>
              </div>
            </div>
          </form>
        </Paper>
      </div>
    )
  }
}

Register.propTypes = {
  register: PropTypes.func,
  t: PropTypes.func,
  classes: PropTypes.object,
}

export default withStyles(styles)(Register)
